export default __webpack_public_path__ + "static/media/IMG_3619.4c2feb50.jpg";